import type { WizardTileConfig } from '../../types/tileConfig';

const TILE_CONFIGS: WizardTileConfig[] = [
  {
    label: 'offerWizard.stepWho.gewerbekunde',
    value: 'gewerbekunde',
    iconComponent: 'GewerbekundeIcon',
    urlValue: 'Gewerbekunde',
  },
  {
    label: 'offerWizard.stepWho.energieversorger',
    value: 'energieversorger',
    iconComponent: 'EnergieversorgerIcon',
    urlValue: 'EnergieVersorger',
  },
  {
    label: 'offerWizard.stepWho.industriekunde',
    value: 'industriekunde',
    iconComponent: 'IndustriekundeIcon',
    urlValue: 'Industriekunde',
  },
  {
    label: 'offerWizard.stepWho.anlagenbetreiber',
    value: 'anlagenbetreiber',
    iconComponent: 'AnlagenbetreiberIcon',
    urlValue: 'Anlagenbetreiber',
  },
];

export default TILE_CONFIGS;
